module.exports = __webpack_public_path__ + "static/media/superBlot-2.4dc0a928.png";